import { ChecklistItemType, RefundRequest } from "../../types";

export const findCheckListItem = (request: RefundRequest, type: ChecklistItemType) => {
  return request.checklistItems.find(i => i.type === type);
};
